import React from "react";
import Aux from "../../../hoc/Auxilliary";
import TopItem from "./TopItem";
import Container from "./TableContainer";

function ClassContent() {
  return (
    <Aux>
      <TopItem />
      <Container />
    </Aux>
  );
}

export default ClassContent;
